import { useCallback } from 'react'

/** @param {{ setThreads: Function, setThreadShareThread: Function }} m */
export function useThreadShareActions(m) {
  const { setThreads, setThreadShareThread } = m
  const closeThreadShare = useCallback(() => {
    setThreadShareThread(null)
  }, [setThreadShareThread])
  const handleUpdateThreadMembers = useCallback(
    (threadId, members) => {
      setThreads((prev) =>
        prev.map((thread) => (thread.id === threadId ? { ...thread, members } : thread)),
      )
      setThreadShareThread(null)
    },
    [setThreads, setThreadShareThread],
  )
  return { closeThreadShare, handleUpdateThreadMembers }
}
